module.exports = __webpack_public_path__ + "img/材料力学5_2_3.eeef98e8.jpg";